import { getCurrentPlatform, PLATFORMS } from "./platform.js";

const COURSE_DASHBOARD_PATH = "/user/courses";

export function getCanonicalLearnerPath(pathname) {
  return pathname === "/user/learning" ? COURSE_DASHBOARD_PATH : pathname;
}

export function getLearnerActivitySections() {
  return ["upcoming_sessions", "batch_bulletin"];
}

export function isProCertLearnerDashboard({ hostname, showProCertHome }) {
  const normalizedHostname = String(hostname || "").toLowerCase();
  if (normalizedHostname.includes("procertcompliance")) return true;
  if (showProCertHome && normalizedHostname === "localhost") return true;
  // Partner custom domains carry no ProCert hostname; getCurrentPlatform()
  // reads the white-label meta tag the edge function injects for them.
  return getCurrentPlatform() === PLATFORMS.PROCERT_COMPLIANCE;
}

export function getCurrentCourseEnrollment(enrollments = []) {
  const available = enrollments.filter((enrollment) => {
    const progress = Number(enrollment?.progress_percentage) || 0;
    return (
      !["completed", "cancelled"].includes(enrollment?.enrollment_status) &&
      progress < 100
    );
  });

  return (
    available.find(
      (enrollment) => Number(enrollment?.progress_percentage) > 0,
    ) ||
    available[0] ||
    null
  );
}
